import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";

/**
 * Gates a section behind authentication. Unauthenticated users are sent to
 * /login?next=<path> so they return to where they were after signing in.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="text-muted-foreground flex min-h-svh items-center justify-center text-sm">
        Loading…
      </div>
    );
  }
  if (!token) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
